module.exports = __webpack_public_path__ + "media/Ok_are_you_ready_short.ea51363a.mp3";